import { NotificationManager } from 'react-notifications';
import axios from 'axios';

import { IPayoutLimit } from '../payoutLimits/types';

export const fetchPaymentLimitsRequest = async (): Promise<IPayoutLimit[] | null> => {
  try {
    const res = await axios.get('api/v1/payment/overall-limits');
    return res.data;
  } catch (error) {
    NotificationManager.error("Can't fetch payment limits");
    return null;
  }
};
